import React, { useState, useEffect } from "react";
import { getLast24HourPromptCount } from '../utils/Universalfunctions';

const Prompt24Item = ({ userData }) => {
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userData?.uid) return;

        const fetchCount = async () => {
            setLoading(true);
            const c = await getLast24HourPromptCount(userData.uid);
            setCount(c);
            setLoading(false);
        };

        fetchCount();
    }, [userData?.uid]);

    if (loading) return <p>Loading...</p>;

    return (
        <>
        <div className="stat">
                <h4>{count}</h4>
                <span>Today's Prompts</span>
            </div>

            <div className="stat">
                <h4>{10 - count}</h4>
                <span>Pending Submissions</span>
            </div>
            </>
    );
};

export default Prompt24Item;